import {ConfirmCodeForm, LoginForm} from "@/components/login";
import {useState} from "react";
import {isEmpty} from "@/utils/global-functions";

export default function LoginCard({overlayClasses = "", userType}) {

    const [loginStep, setLoginStep] = useState(1);
    const [mobileCheckData, setMobileCheckData] = useState({});

    const onStepChange = (step, data = {}) => {
        if (!isEmpty(data)) {
            setMobileCheckData(data)
        }

        setLoginStep(step)
    }

    return (
        <div className="relative flex justify-center">
            <div className={`rounded-[2.875rem] h-[calc(100%+1rem)] w-[90%] max-w-[24.563rem] sm:w-[24.563rem] absolute -top-2 ${overlayClasses}`} />
            <div className="relative w-full max-w-[30.5rem] sm:w-[30.5rem] rounded-[2.563rem] bg-pol-light-7 pt-10 pb-[1.875rem] px-3.5 sm:px-[3.125rem]">
                {
                    loginStep === 1 ?
                        <LoginForm
                            userType={userType}
                            prevMobile={mobileCheckData.mobile}
                            onNext={(data) => onStepChange(2, data)}
                        /> :
                        <ConfirmCodeForm
                            checkData={mobileCheckData}
                            userType={userType}
                            onPrev={() => onStepChange(1)}
                        />
                }
            </div>
        </div>
    )
}
